module.exports = __webpack_public_path__ + "static/media/n-title-me-icon.18952e3a.svg";